/**
 *
 * WebsiteFooter
 *
 */

import React from 'react';

declare const top: any;

interface FooterProps {
  //
}

const WebsiteFooter: React.FC<FooterProps> = () => {
  return (
    <div className="fusion-footer">
      <footer
        id="footer"
        className="fusion-footer-copyright-area fusion-footer-copyright-center"
      >
        <div className="fusion-row">
          <div className="fusion-copyright-content">
            <div className="fusion-copyright-notice" style={{ paddingBottom: 0 }}>
              <div>
                © Copyright by Blumatix Intelligence GmbH | Schwarzstraße 48 | 5020
                Salzburg/Austria |{" "}
                <a href="tel:+43662243410" target="_top">
                  Telefon: +43 662 243410
                </a>
                <br />
                <a href="https://www.blumatix.com/content/AGB.pdf" target="_top">
                  AGB
                </a>
                {" "}|{" "}
                <a href="https://www.bludelta.de/de/dataprivacy/" target="_top">
                  Datenschutz
                </a>
                {" "}|{" "}
                <a href="#" onClick={()=> { top.CCM.openWidget(); return false;}} target="_top">
                  Cookie-Konfiguration
                </a>
                <p>
                  <a
                    style={{ color: "#666" }}
                    href="https://www.interactmultimedia.at"
                    target="_top"
                  >
                    Website by Webagentur interact!multimedia (Salzburg - St.
                    Pölten)
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default WebsiteFooter;
